export const scrollToNotificationContent = (targetId: string, containerRef?: React.RefObject<HTMLDivElement>) => {
    const target = document.getElementById(targetId);
    const container = containerRef?.current;
    if (container && target) {
        // make sure the container itself is on-screen
        const cRect = container.getBoundingClientRect();
        if (cRect.top < 0 || cRect.bottom > window.innerHeight) {
            container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        // now only scroll _inside_ the container if the target is out of view
        const tRect = target.getBoundingClientRect();
        const topPadding = 10;

        const relativeTop = tRect.top - cRect.top; // negative if above
        const relativeBottom = tRect.bottom - cRect.bottom; // positive if below

        let scrollBy = 0;
        if (relativeTop < 0) {
            // target is above visible area → scroll up just enough
            scrollBy = relativeTop - topPadding;
        } else if (relativeBottom > 0) {
            // target is below visible area → scroll down just enough
            scrollBy = relativeBottom + topPadding;
        } else {
            // already fully visible → nothing to do
            return;
        }

        container.scrollBy({ top: scrollBy, behavior: 'smooth' });
        return;
    }

    // fallback: scroll the page to the element
    if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
